export var PaymentPromiseStatus;
(function (PaymentPromiseStatus) {
    PaymentPromiseStatus["OPEN"] = "open";
    PaymentPromiseStatus["KEPT"] = "kept";
    PaymentPromiseStatus["BROKEN"] = "broken";
    PaymentPromiseStatus["CANCELLED"] = "cancelled";
})(PaymentPromiseStatus || (PaymentPromiseStatus = {}));
export var PaymentPromiseSource;
(function (PaymentPromiseSource) {
    PaymentPromiseSource["USER"] = "user";
    PaymentPromiseSource["PORTAL"] = "portal";
    PaymentPromiseSource["ESCALATION"] = "escalation";
    /** From the follow ups suggested after a click to call */
    PaymentPromiseSource["CALL"] = "call";
})(PaymentPromiseSource || (PaymentPromiseSource = {}));
//# sourceMappingURL=paymentPromise.js.map